import { render, staticRenderFns } from "./PolicyScope.vue?vue&type=template&id=01d69e78&"
import script from "./PolicyScope.vue?vue&type=script&lang=js&"
export * from "./PolicyScope.vue?vue&type=script&lang=js&"
import style0 from "./PolicyScope.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports